export default __webpack_public_path__ + "static/media/generalthai.2356fce7.jpg";